import { useNavigate } from '@hulu/react-router-dom';
import { AccountMenu } from '@hulu/react-style-components';
import React, { useContext, useRef, useState } from 'react';

import { GhostModeContext } from '../../../context/GhostMode/GhostMode';
import useOnClickOutside from '../../../hooks/useOnClickOutside/useOnClickOutside';
import { User } from '../../../utils/user';
import CustomDropDown from '../../CustomDropDown/CustomDropDown';
import { StyledUserName } from '../../Header/UserCard/styled';
import { DropDownItem } from '../../types';
import { getDropDownList } from './utils';

const UserCard = (): JSX.Element | null => {
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState<boolean>(false);
  const { isGhostMode } = useContext(GhostModeContext);

  const handleMenuClick = (): void => {
    setIsActive((value) => !value);
  };

  const handleItemClick = (item: DropDownItem): void => {
    if (isGhostMode) {
      navigate(item.url);
    } else {
      User.logout();
    }
  };

  const userInfo = User.getUserInfo().userInfo;

  useOnClickOutside(ref, () => setIsActive(false));

  if (!userInfo) {
    return null;
  }

  return (
    <StyledUserName ref={ref} $isActive={isActive} data-testid="userCardMenu">
      <AccountMenu firstName={userInfo.email} lastName="" onClick={handleMenuClick} isOpen={isActive}>
        {isActive && <CustomDropDown handleItemClick={handleItemClick} list={getDropDownList(isGhostMode)} />}
      </AccountMenu>
    </StyledUserName>
  );
};

export default UserCard;
